module.exports = __webpack_public_path__ + "static/media/sin_depositos.382a34f7.png";